import React from 'react';
import GelEnvelopeDashboardPage from '../GelEnvelopeDashboardPageV2';

/* G133 — wire scoped Audit to v2 GEL envelope dashboard. */
export default function ExternalAuditPage() {
  return <GelEnvelopeDashboardPage agentScope="external" />;
}
